/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-29 10:05:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-20 14:48:18
 */
import http from '../httpConfig'
const table = 'mrbase_sys_flow_proxy_approval'


//人员下拉数据  
export const getStaffListForFilter = (params = {}) => {
  params['~table~'] = 'mrbase_sys_staffs'
  return new Promise((resolve, reject) => {
    http.post('/api/staff-manager/find-staff_condition/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

